module.exports = __webpack_public_path__ + "fonts/iconfont.08b07966.woff";